import styled from 'styled-components';

export default styled.div`
  color: blue;
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  padding: 20px;
  grid-gap: 20px;
`;
